import React from "react";
import { CsvButton } from "../../CsvButton";
import { ReactTableServerSide } from "../../ReactTableServerSide";
import Popup from "reactjs-popup";
import auth from "../../../Auth";
import { datasetAll, action_update, datasetViewCols, clinicalDataDownload, policyDataDownload, extraFileDownload } from "../../../apis";
import { Typography, Grid } from "@material-ui/core";
import GPAP_BUTTON from "../../../../gpap-lib/Button_Collection";
import "../../custom_material_ui_like.css";
import IconButton from "@material-ui/core/IconButton";

import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import "./datasets-view.css";
import Tooltip from "@material-ui/core/Tooltip";

import {
  toggleRow,
  toggleSelectAll,
  updateTable,
  createIconOwner,
} from "../../components/TableMethods.js";

import CustomizeColumns from "./CustomizeColumns";
import ShareDataDialog from "./ShareDataDialog";

import { Link } from "react-router-dom";

const { config } = window;

/**
 * Component for showing all created Datasets.
 * @component
 * @category Category
 * @subcategory Submitted
 */
export class DatasetsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // headers: config.datasetsViewHeaders,
      headers: [],
      experiments: [],
      actions: [
        { value: "unselected", name: "----" },
        { value: "shareWithGroups", name: "Share with groups" },
        { value: "unShareWithGroups", name: "Unshare with groups" },
      ],
      actionSelected: "unselected",
      pagination: {
        loadData: true,
        page: 0,
        pages: 0,
        pageSize: 100,
        totalItems: 0,
        fields: [],
        filtered: [],
        sorted: [],
      },
      datasets: [],
      selected: [],
      selectedFields: {},
      selectAll: 0,
      popupErrors: "",
      csvData: [],
      csvFileName: "",
      redirectExperimentInformation: "",
      columnsShown: [],
      open: false,
      setOpen: false,
      defaultColumnsBool: true,
    };

    this.getCsvData = this.getCsvData.bind(this);
    this.csvLink = React.createRef();

    //needed for CustomizeColumns
    this.updateColumns = this.updateColumns.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.getDataColumnTable = this.getDataColumnTable.bind(this);
    this.isSelected2 = this.isSelected2.bind(this);
  }

  async getViewCols() {
    let jsonData = {};

    try {
      const response = await datasetViewCols(
        auth.getToken(),
        config.api_endpoint
      );
      jsonData = await response.json();
      return jsonData[0].headers;
    } catch (error) { }
  }

  async componentDidMount() {
    if (auth.tokenExpired()) {
      this.setState({
        popupErrors: "Session expired. Please login again",
      });
    }
    const headersNew = await this.getViewCols();
    this.setState({ headers: headersNew });
  }

  isSelected2 = (id, selectedObj) => {
    if (selectedObj.length === 0) {
      return false;
    }
    for (const selected of selectedObj) {
      if (selected.id === id) {
        return true;
      }
    }
    return false;
  };

  getDataColumnTable() {
    // debugger;
    //add selection checkbox
    const columnCheckbox = {
      // self.state.selectAll
      // nothing = 0 -> checkbox is unchecked
      // all = 1 -> checkbox is checked
      // one/multiple = 2 -> checkbox is indeterminate

      id: "checkbox",

      Cell: ({ original, index, viewIndex }) => {
        return (
          <input
            data-cy={`select-row-checkbox-${index}`}
            type="checkbox"
            className="checkbox"
            checked={this.isSelected2(original.id, this.state.selected)}
            // checked={isSelected(original.id, this.state.selected)}
            onChange={() =>
              this.setState({
                selected: toggleRow(original, this.state.selected),
                selectAll: 2,
              })
            }
          />
        );
      },
      Header: (x) => (
        <span>
          Select{" "}
          <input
            data-cy="select-all-checkbox"
            type="checkbox"
            className="checkbox"
            checked={this.state.selectAll === 1}
            ref={(input) => {
              if (input && this.state.selectAll === 2) {
                if (this.state.selected.length === 0) {
                  input.checked = false;
                } else {
                  input.indeterminate = true;
                }
              }
            }}
            onChange={() =>
              this.setState({
                selected: toggleSelectAll(
                  this.state.selectAll,
                  this.state.experiments
                ),
                selectAll: this.state.selectAll === 0 ? 1 : 0,
              })
            }
          />
        </span>
      ),
      sortable: false,
      filterable: false,
      width: 80,
    };

    // TODO add a column for the link to the data policy file

    const handleClick = async (event, rowId, fileType) => {
      event.preventDefault();
      const query = {
        datasetId: rowId,
        fileType,
      }
      // TODO
      // would be good to have for this a generic function
      let res = null;
      res = await extraFileDownload(
        auth.getToken(),
        config.api_endpoint,
        JSON.stringify(query)
      );

      // res = fileType === "clinical" ? await clinicalDataDownload(
      //   auth.getToken(),
      //   config.api_endpoint,
      //   JSON.stringify(query)
      // ) : await policyDataDownload(
      //   auth.getToken(),
      //   config.api_endpoint,
      //   JSON.stringify(query)
      // );

      if (res.status !== 200) {
        // TODO
        // show an error message
        // to the user
        return;
      }
      const data = await res.json();
      const presignedUrl = data.presigned_url;

      // redirect to the presigned url
      // TODO
      // below works but it is not considered to be best practice
      // to be more consistent with the rest of the code
      // it would be better to use the react router { withRouter }
      window.open(presignedUrl, '_self');


      // TODO
      // this should trigger the creation of a presigned url
    }

    const columnDataPolicy = {
      id: "dataPolicy",

      // TODO
      // Do not define the button during the render
      Cell: ({ original }) => {
        if (original.policy_file === undefined || original.policy_file.length === 0) {
          return "";
        }
        return (
          <a
            href={"#"}
            onClick={
              (event) => handleClick(event, original.id, "dataPolicy")
            }
          >
            {original.policy_file[0]}
          </a>
        )
      },
      Header: "Data Policy",
      sortable: false,
      filterable: false,
      width: 120,
    };

    const columnClinicalData = {
      id: "clinicalData",
      Cell: ({ original }) => {
        if (original.clinical_file === undefined || original.clinical_file.length === 0) {
          return "";
        }
        return (
          <a
            href={"#"}
            onClick={
              (event) => handleClick(event, original.id, "clinical")
            }
          >
            {original.clinical_file[0]}
          </a>
        )
      },
      Header: "Clinical Data",
      sortable: false,
      filterable: false,
      width: 120,
    };

    // const columnClinicalData = {
    //   id: "clinicalData",

    //   Cell: ({ original }) => {
    //     if (original.clinicalData === "") {
    //       return <div />;
    //     } else {
    //       const val = original.clinical_presigned_url;
    //       return <a href={val}> {val} </a>;
    //     }
    //   },
    //   Header: "Clinical Data",
    //   sortable: false,
    //   filterable: false,
    //   width: 120,
    // };

    const columns = [
      columnCheckbox,
      createIconOwner(),
      columnDataPolicy,
      columnClinicalData,
    ];

    return updateTable(
      columns,
      this.state.columnsShown,
      this.state.headers,
      this.state.experiments,
      this.state.defaultColumnsBool
    );
  }

  handleUpdate = async (valueSelected) => {

    debugger;

    const projectIdToDatasets = {};

    for (const dataset of Object.entries(this.state.selected)) {
      const values = dataset[1];

      if (!projectIdToDatasets.hasOwnProperty(values.project_id)) {
        projectIdToDatasets[values.project_id] = [];
      }
      projectIdToDatasets[values.project_id].push(values.dataset_id);
    }

    let action = "addGroup";
    if (this.state.actionSelected !== "shareWithGroups") {
      action = "removeGroup";
    }

    const responses = [];
    for (const projectId in projectIdToDatasets) {
      const datasetIds = projectIdToDatasets[projectId].join(",");
      const queryUrl = `datasets?arg=${action}&project=${projectId}&dataset=${datasetIds}&group=${valueSelected}`;

      const response = await action_update(
        auth.getToken(),
        config.api_endpoint,
        queryUrl,
        "PUT"
      );
      responses.push(response);
    }

    // TODO
    // at the moment it fails if there is an error in any of the responses
    // would be better if it would let the ones that succeed
    // pass and only show the error of the failed ones

    if (responses.every((r) => r.status === 200)) {
      // if (response.status === 200) {
      const { page, pageSize, filtered, sorted } = this.state.pagination;

      const data_query = {
        page,
        pageSize,
        filtered,
        sorted,
      };

      this.getData(data_query, filtered, sorted);

      // clear the selection tick boxes
      this.setState({
        selected: [],
        selectAll: 0,
      });
      return;
    }

    // TODO
    // this needs to have a test

    // loop over responses and find the ones that failed
    const proj_ids = new Set();
    for (const response of responses) {
      if (response.status !== 200) {
        const res = await response.json();

        if (res.message == "dataset visibility is not changeable") {
          proj_ids.add(res.project);
        }
      }
    }

    this.setState({
      popupErrors: `The datasets of ${[...proj_ids].join(
        ", "
      )} cannot be shared/unshared`,
    });
  };

  getActionSelect = () => (
    <Grid container>
      <Grid item xs={12}>
        <span style={{ marginLeft: "10px" }}>
          Datasets Selected: {Object.keys(this.state.selected).length}
        </span>
        <label>
          <Tooltip title="Owner Icon">
            <IconButton aria-label="Owner">
              <AccountCircleIcon />
            </IconButton>
          </Tooltip>
          Share/Unshare:
        </label>
        <select
          className="mx-2 my-2"
          value={this.state.actionSelected}
          onChange={this.handleSelectChange}
          data-cy={"action-select"}
        >
          {this.state.actions.map((action, key) => (
            <option key={key} value={action.value}>
              {action.name}
            </option>
          ))}
        </select>

        {this.state.actionSelected !== "unselected" &&
          Object.keys(this.state.selected).length > 0 ? (
          // Open Dialog
          <ShareDataDialog
            type={"datasets"}
            handleUpdate={this.handleUpdate}
            action={this.state.actionSelected}
            selected={this.state.selected}
          />
        ) : (
          // Button is set to disabled if no row is selected
          <GPAP_BUTTON disabled={true} data-cy={"btn-select-groups"}>
            select groups
          </GPAP_BUTTON>
        )}
      </Grid>
    </Grid>
  );

  /*Handler Action Select click*/
  handleSelectChange = (event) => {
    this.setState({ actionSelected: event.target.value });
  };

  closeModal = () => {
    if (this.state.popupErrors === "Session expired. Please login again") {
      auth.user.keycloak.logout();
    }
    this.setState({ popupErrors: "" });
  };

  // TODO
  /* Define a method to control Row Clicks*/
  onRowClick = (state, rowInfo, column, instance) => ({
    onClick: (e) => {
      /*1.If row is Experiment ID then Route to Experiment Information*/
      if (rowInfo && column.id === "ExperimentID") {
        this.setState({
          redirectExperimentInformation: rowInfo.original.ExperimentID,
        });
      }
    },
  });

  getData = async (data_query, filtered, sorted) => {
    /* Call POST Data*/
    datasetAll(auth.getToken(), config.api_endpoint, JSON.stringify(data_query))
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          experiments: data.items,
          pagination: {
            page: data._meta.page,
            pages: data._meta.total_pages,
            pageSize: data._meta.page_size,
            totalItems: data._meta.total_items,
            // fields: fields,
            filtered,
            sorted,
            loadData: false,
          },
        });
      });
  };

  /*Method to call API Endpoint to get React Table Data*/
  loadTableData = (state, instance) => {

    /*Call API Endpoint*/
    let data_query = {
      page: state.page + 1,
      pageSize: state.pageSize
      // fields: fields,
    };
    /*Check filtered Criteria*/
    if (state.filtered) {
      data_query.filtered = state.filtered.map((item) => ({
        id: item.id,
        value: item.value,
      }));
    }
    /*Check sorted Criteria*/
    if (state.sorted) {
      data_query.sorted = state.sorted;
    }

    /* Call POST Data*/
    this.getData(data_query, state.filtered, state.sorted);
  };

  getCsvData = async (headers) => {
    /*Get All Data to be printed to CSV Files*/
    const data_query = {
      page: 1,
      pageSize: this.state.pagination.pageSize,
      fields: this.state.pagination.fields,
      filtered: this.state.pagination.filtered.map((item) => ({
        id: item.id,
        value: [item.value],
      })),
      sorted: this.state.pagination.sorted,
    };

    let getData = true;
    const allItems = [];
    /*Get All Data*/
    while (getData) {
      /*Call POST Data*/
      await datasetAll(
        auth.getToken(),
        config.api_endpoint,
        JSON.stringify(data_query)
      )
        .then((response) => response.json())
        .then((data) => {
          allItems.push(...data.items);
          if (data_query.page < data._meta.total_pages) {
            getData = true;
            data_query.page = data_query.page + 1;
          } else getData = false;
        });
    }
    //Build data for CSV
    const data = [];

    for (let item of allItems) {
      const row = {};
      //1. Loop Headers
      for (let header of this.state.headers) {
        row[header.key] =
          typeof item[header.key] === "boolean"
            ? item[header.key].toString()
            : item[header.key];
      }
      //2. Add row to data
      data.push(row);

      // TODO
      // remove the ID column
    }

    const today = new Date().toISOString().slice(0, 10);
    this.setState(
      { csvData: data, csvFileName: `${today}_dataset_list.csv` },
      () => {
        // click the CSVLink component to trigger the CSV download
        this.csvLink.current.link.click();
      }
    );
  };

  updateColumns(columns) {
    //needed for CustomizeColumns
    this.setState({ columnsShown: columns });
    this.setState({ defaultColumnsBool: false });
  }

  // ! FIXME
  // after pressing update the pagination (top right)
  // does not behave as expected
  // starts with 1-10 of 2 records
  // after pressing update the pagination starts with 11-20 of 2 records
  // with every update the pagination increases by 10

  // this happens also when updating the values in the project table

  // note: the changes do not persist after reloading the page
  // it is again 1-10 of 2 records

  render() {
    /*Show popup in case an error with the loggin occurs*/
    if (this.state.popupErrors) {
      return (
        <Popup open={true} closeOnDocumentClick onClose={this.closeModal}>
          <div>
            <button className="close" onClick={this.closeModal}>
              {" "}
              &times;{" "}
            </button>
            <div className="page-header">
              {" "}
              <h1>Logging error</h1>{" "}
            </div>
            <div className="alert alert-warning">{this.state.popupErrors} </div>
          </div>
        </Popup>
      );
    }

    //TODO
    /*Redirect to Experiment Info View If Cell Experiment ID Is Clicked */
    // if (this.state.redirectExperimentInformation !== "") {
    //   return (
    //     <Redirect
    //       to={{
    //         pathname: `/experimentinfo/${this.state.redirectExperimentInformation}`,
    //       }}
    //     />
    //   );
    // }

    const columnsDataTable = this.getDataColumnTable();
    return (
      <Grid container>
        <Grid item xs={12}>
          <Typography variant={"h5"} align={"center"}>
            {" "}
            List of Datasets{" "}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {/* <GPAP_BUTTON_LIGHT href="#/management" startIcon={<ArrowBackIcon />}>
            Back
          </GPAP_BUTTON_LIGHT> */}
          {/* Adds select table columns */}
          <CustomizeColumns
            // type={"datasets"}
            headers={this.state.headers}
            updateColumns={this.updateColumns}
          />
          <CsvButton
            getCsvData={this.getCsvData}
            csvData={this.state.csvData}
            headersCsv={this.state.headers}
            nameFile={this.state.csvFileName}
            csvLink={this.csvLink}
          />
        </Grid>

        <Grid item xs={6}>
          {this.getActionSelect()}
        </Grid>
        <Grid item xs={6} style={{ padding: "6px" }}>
          {Object.keys(this.state.selected).length > 0 ? (
            <Link
              to={{
                pathname: "/files",
                state: {
                  selectedDatasets: this.state.selected,
                },
              }}
            >
              <GPAP_BUTTON>
                Show to the selected dataset/s associated files
              </GPAP_BUTTON>
            </Link>
          ) : (
            <Link to={"/files"}>
              <GPAP_BUTTON data-cy={"show-all-files"}>
                Show all files
              </GPAP_BUTTON>
            </Link>
          )}
        </Grid>
        <Grid item xs={12}>
          {/* maybe at one point we need to be able to click on a dataset */}
          {/* <Box p={2} className={"info"}>
          <Typography variant={"subtitle1"}>
            Click on an Dataset ID to see the details of the dataset
          </Typography>
        </Box> */}

          <ReactTableServerSide
            headers={this.state.headers}
            columns={columnsDataTable[0]}
            data={columnsDataTable[1]}
            pagination={this.state.pagination}
            onRowClick={this.onRowClick}
            loadTableData={this.loadTableData}
            loading={this.state.pagination.loadData}
            // TODO get the fields delay info from the backend
            fieldsDelay={["dataset_id", "project_id"]}
          />
        </Grid>
      </Grid>
    );
  }
}
